module.exports = __webpack_public_path__ + "img/page_show.44538e79.png";